export default function ({commit, getters}, value) {
    commit('set', {
        old: JSON.stringify(getters.data),
        visible: true,
    })
}